import React, { useEffect, useRef, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    clarity: any;
    ttq: any;
    pixelId: string;
  }
}
export function App() {
  const pixelInitialized = useRef(false);
  useEffect(() => {
    // Prevent double initialization
    if (pixelInitialized.current) return;
    pixelInitialized.current = true;
    // Meta Pixel Code
    const fbScript = document.createElement('script');
    fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1162039622301528');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
    // Microsoft Clarity Code
    const clarityScript = document.createElement('script');
    clarityScript.type = 'text/javascript';
    clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "uk5jgjheh9");
    `;
    document.head.appendChild(clarityScript);
    // UTMify Tracking Code
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-xcod-sck', '');
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    // UTMify Pixel Code
    window.pixelId = '6938ef9a668fdd3e9804ce96';
    const utmifyPixelScript = document.createElement('script');
    utmifyPixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    utmifyPixelScript.async = true;
    utmifyPixelScript.defer = true;
    document.head.appendChild(utmifyPixelScript);
    // TikTok Pixel Code
    const tiktokScript = document.createElement('script');
    tiktokScript.innerHTML = `
      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
        var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
        ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
        ttq.load('D50VKQRC77UBHHBF3TU0');
        ttq.page();
      }(window, document, 'ttq');
    `;
    document.head.appendChild(tiktokScript);
    return () => {
      // Cleanup on unmount
      if (fbScript.parentNode) document.head.removeChild(fbScript);
      if (clarityScript.parentNode) document.head.removeChild(clarityScript);
      if (utmifyScript.parentNode) document.head.removeChild(utmifyScript);
      if (utmifyPixelScript.parentNode) document.head.removeChild(utmifyPixelScript);
      if (tiktokScript.parentNode) document.head.removeChild(tiktokScript);
    };
  }, []);
  return <LandingPage data-id="element-0" />;
}